/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-06-01 16:51:21
//  */
import store from "../index";
// import router from '../../router/index'
export default {
  state: {
    info: "" // 每次刷新都要通过token请求个人信息来筛选动态路由
  },
  mutations: {
    getInfo(state, data) {
      if (data.authorityRouter && data.authorityRouter.indexOf(",") != -1) {
        data.authorityRouter = data.authorityRouter.split(",");
      } else if (data.authorityRouter == null) {
        data.authorityRouter = [];
      }
      state.info = {
        authorityRouter: data.data.menuList
        // avatar: data.avatar ? data.avatar : "/static/images/logo.png",
        // uid: data.id
      };
      sessionStorage.setItem("info", JSON.stringify(store.getters.info));
    },
  },

  actions: {
    getInfo({ commit }, data) {
      commit("getInfo", data);
    },
  }
};



// WEBPACK FOOTER //
// ./src/vuex/modules/role.js